import { Component, Input } from '@angular/core';
import { UtilsService } from 'app/helpers/services';
import { CompRouterService } from 'app/helpers/services/core/comp-router.service';

@Component({
  selector: 'app-moc-analytics-card',
  templateUrl: './moc-analytics-card.component.html',
  styleUrls: ['./moc-analytics-card.component.scss']
})
export class MocAnalyticsCardComponent {
  @Input() data: any;
  @Input() loading: boolean = false;

  tooltipVisible: boolean = false;
  tooltipContent: string = '';
  tooltipX: number = 0;
  tooltipY: number = 0;
  hoveredCircleIndex: number = -1;

  constructor(public compRouter: CompRouterService, public utils: UtilsService) {}

  showTooltip(event: MouseEvent, rating: number) {
    if (!rating) return;
    
    this.tooltipContent = rating.toFixed(1);

    const circleElement = event.currentTarget as SVGCircleElement;
    const index = parseInt(circleElement.getAttribute('data-index') || '-1');
    this.hoveredCircleIndex = index;
    
    const target = event.currentTarget as SVGCircleElement;
    const svgElement = target.ownerSVGElement;
    
    if (svgElement) {
      const svgRect = svgElement.getBoundingClientRect();
      const circleX = parseFloat((target as any).getAttribute('cx'));
      const circleY = parseFloat((target as any).getAttribute('cy'));
      
      const scaleX = svgRect.width / 180; 
      const scaleY = svgRect.height / 100; 
      
      this.tooltipX = circleX * scaleX;
      this.tooltipY = circleY * scaleY - 15; 
    } else {
      this.tooltipX = event.clientX + 10;
      this.tooltipY = event.clientY - 40;
    }
    
    this.tooltipVisible = true;
  }

  hideTooltip() {
    this.tooltipVisible = false;
    this.hoveredCircleIndex = -1;
  }

  goToDetailedAnalytics() {
    this.compRouter.routeToContextUrls('mood-of-the-crew-analytics');
  }

  get weeklyTrend() {
    return this.data && this.data.weeklyTrend ? this.data.weeklyTrend : [];
  }

  get trendPoints(): string {
    const trend = this.weeklyTrend;
    if (!trend.length) {
      return '';
    }

    // Get min and max for scaling
    const ratings = trend.map((item: any) => item.averageRating);
    const min = Math.min(...ratings);
    const max = Math.max(...ratings);
    
    // SVG size for better visibility
    const width = 180;
    const height = 100;
    const topPadding = 16;
    const bottomPadding = 28;
    const actualHeight = height - topPadding - bottomPadding;
    const n = trend.length > 1 ? trend.length - 1 : 1;

    return trend
      .map((item: any, i: number) => {
        // X: Distribute from 0 to full width
        const x = (i * width) / n;
        
        // Y: Scale so max is at top, min at bottom with padding
        let y;
        if (max === min) {
          y = height / 2;
        } else {
          y = topPadding + actualHeight - ((item.averageRating - min) / (max - min)) * actualHeight;
        }
        
        return `${x},${y}`;
      })
      .join(' ');
  }
}